import React from 'react';
import CommentBankIcon from '../../../static/icons/banks.svg';
import { SelectableFeedbackType } from './shared/SelectableFeedbackType';

export const CommentBanksFeedbackType = ({
  formData,
  updateFormData,
  allCommentBanks = [],
  onCommentBankPreview,
  showLabel = true,
  showTooltip = true,
  filterSubject = null,
  placeholder = null,
  hideGoToLink = false,
}) => {
  const getSelectedItem = (formData, allItems) => {
    return allItems.find(cb => cb.id === formData.commentBankId);
  };

  const handleSelect = (commentBank) => {
    updateFormData({
      commentBankId: commentBank.id,
      commentBank: commentBank,
    });
  };

  const handleDelete = () => {
    updateFormData({ commentBankId: '', commentBank: null });
  };

  const handlePreview = () => {
    if (formData.commentBankId && onCommentBankPreview) {
      onCommentBankPreview(formData.commentBankId);
    }
  };

  const selectedItem = getSelectedItem(formData, allCommentBanks);

  return (
    <SelectableFeedbackType
      formData={formData}
      updateFormData={updateFormData}
      allItems={allCommentBanks}
      onPreview={handlePreview}
      icon={CommentBankIcon}
      label="Comment Banks"
      tooltipText="Learn more about Comment Banks"
      selectedItem={selectedItem}
      getSelectedItem={getSelectedItem}
      onSelect={handleSelect}
      onDelete={handleDelete}
      goToRoute="/tools/commentbanks"
      popupItemType="Comment Bank"
      hideTypeFilter={true}
      showLabel={showLabel}
      showTooltip={showTooltip}
      filterSubject={filterSubject}
      placeholder={placeholder}
      hideGoToLink={hideGoToLink}
    />
  );
};
